import { Skeleton } from '@ds';
import styles from './HomeSkeleton.module.scss';

const TAB_COUNT = 6;
const DETAIL_FIELD_COUNT = 4;
const STAGE_COUNT = 4;

interface IHomeSkeletonProps {
  showTabs?: boolean;
}

const HomeSkeleton = ({ showTabs = true }: IHomeSkeletonProps) => (
  <div>
    {showTabs && (
      <div className={styles['home-skeleton__tabs']} data-testid="home-skeleton-tabs">
        {Array.from({ length: TAB_COUNT }).map((_, idx) => (
          <Skeleton key={idx} width="92px" height="32px" />
        ))}
      </div>
    )}

    <div className={styles['home-skeleton__case-details']} data-testid="home-skeleton-case-details">
      {Array.from({ length: DETAIL_FIELD_COUNT }).map((_, idx) => (
        <div key={idx} className={styles['home-skeleton__case-detail-item']}>
          <Skeleton width="80px" height="12px" />
          <Skeleton width="140px" height="14px" />
        </div>
      ))}
    </div>

    <div className={styles['home-skeleton__timeline-header']}>
      <Skeleton width="140px" height="24px" />
      <Skeleton width="100px" height="16px" />
    </div>

    <div className={styles['home-skeleton__timeline']} data-testid="home-skeleton-timeline">
      {Array.from({ length: STAGE_COUNT }).map((_, idx) => (
        <div key={idx} className={styles['home-skeleton__stage']}>
          <div className={styles['home-skeleton__stage-name']}>
            <Skeleton shape="circle" width="24px" height="24px" />
            <Skeleton width="160px" height="16px" />
          </div>
          <Skeleton className={styles['home-skeleton__stage-body']} width="100%" height="56px" />
        </div>
      ))}
    </div>
  </div>
);

export default HomeSkeleton;
